<script setup>
import {computed} from 'vue'
import AlertDangerSimple from '@shared-components/ui/alerts/AlertDangerSimple.vue'

const props = defineProps({
  reasons: {
    type: Array,
    default: () => [],
  },
})

const REASON_MESSAGES = {
  provider_not_supported: 'This provider does not support top-up right now.',
  account_disabled: 'The account may be blocked.',
}

const messages = computed(() => props.reasons.map(reason => REASON_MESSAGES[reason]).filter(Boolean))
</script>

<template>
  <alert-danger-simple class="fs-13-px">
    Unable to top up the advertising account. Possible reasons:
    <ul v-if="messages.length" class="custom my-1 pl-7">
      <li v-for="message in messages" :key="message">{{ message }}</li>
    </ul>
    <ul v-else class="custom my-1 pl-7">
      <li>The account may be blocked.</li>
      <li>A credit line is activated.</li>
    </ul>
    If the problem persists, please contact your manager for further information.
  </alert-danger-simple>
</template>
